export default __webpack_public_path__ + "static/media/businessAddressIcon.25ccccc1.svg";